const delay = ms => new Promise(res => setTimeout(res, ms));
import React, { useEffect, useState } from 'react';
import Grid from '@mui/system/Unstable_Grid';
import { Alert, Avatar, Box, Breadcrumbs, Button, Card, CardContent, CardHeader, CircularProgress, Fab, IconButton, InputAdornment, Link, List, ListItem, ListItemAvatar, ListItemText, MenuItem, Stack, Tab, Tabs, TextField, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import { mdiPlusCircleOutline, mdiContentSave, mdiMinusCircleOutline, mdiPencil, mdiWindowRestore, mdiImagePlus, mdiFileDocument, mdiMagnify, mdiCheckBold } from '@mdi/js';
import moment from 'moment';
import Icon from '@mdi/react';
import { useModal } from 'mui-modal-provider';
import { DynamicCard, MdiIcon, WaitDialog } from '@components';
import InputComponent from './inputComponent';
import { DialogDefeitos } from './dialogDefeitos';
import { DialogImage } from './dialogImage';
import { DialogValidacao } from './dialogValidacao';
import { DialogResultado } from './dialogResultado';
import { DialogRequired } from './dialogRequired';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DialogAssinatura } from './dialogAssinatura';
const EditRelatorios = ({ $state, ListaRelatorioService, UIService }) => {
    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState(false);
    const [data, setData] = useState();
    const [imagens, setImagens] = useState([]);
    const [tabParametroIndex, setTabParametroIndex] = useState(0);
    const [tabEnsaioIndex, setTabEnsaioIndex] = useState(0);
    const [tabEquipamentoIndex, setTabEquipamentoIndex] = useState(0);
    const [respostas, setRespostas] = useState();
    const [defects, setDefects] = useState([]);
    const [detalhes, setDetalhes] = useState();
    const [showObservations, setShowObservations] = useState({});
    const [addObservations, setAddObservations] = useState({});
    const [observations, setObservations] = useState([]);
    const [selectedFile, setSelectedFile] = useState();
    const [newImageUrl, setNewImageUrl] = useState(null);
    const [showMotivos, setShowMotivos] = useState();
    const [listaMotivos, setListaMotivos] = useState([]);
    const [missingParametros, setMissingParametros] = useState([]); // Guardar parametros não preenchidos
    const [missingEnsaios, setMissingEnsaios] = useState([]); // Guardar ensaios não preenchidos
    const [formasPagamento, setFormasPagamento] = useState([]);
    const userId = ListaRelatorioService.getUserId();
    const { showModal } = useModal();
    const isEditing = async () => {
        // If we are saving changes
        if (editing) {
            if (data.realizada && (missingParametros.length > 0 || missingEnsaios.length > 0 || (data.realizada && data.motivoId == null))) {
                showModal(DialogRequired, {
                    assinatura: (data.assinatura == null || data.assinatura.length == 0) && data.CoreListaRelatorio.assinatura == 1,
                    pagamento: (data.pagamentoData == null || data.pagamentoFormaId == null || data.pagamentoMontante == null || data.pagamentoRecibo == null) && data.CoreListaRelatorio.pagamento == 1,
                    parametros: missingParametros,
                    ensaios: missingEnsaios,
                    realizada: data.realizada == 1,
                    motivo: data.motivoId
                });
            }
            else {
                const d = await UIService.showConfirm('Tem a certeza que deseja guardar as alterações?');
                for (let key in showObservations) {
                    if (showObservations.hasOwnProperty(key)) {
                        showObservations[key] = false;
                    }
                }
                for (let key in addObservations) {
                    if (addObservations.hasOwnProperty(key)) {
                        addObservations[key] = false;
                    }
                }
                if (d) {
                    let o = showModal(WaitDialog, { title: 'Por favor aguarde...' });
                    // Save data
                    try {
                        if (!moment(data.dataSubmissao).isValid()) {
                            await ListaRelatorioService.saveDataSubmissao(data, moment().format());
                        }
                        // Calculo do resultado, defini-se a 0 para "recalcular"
                        data.resultadoId = 0;
                        data.processado = 0;
                        const r = await ListaRelatorioService.saveResposta(data);
                        if (selectedFile != null) {
                            await ListaRelatorioService.uploadTemplate('upload', 'photos', selectedFile);
                        }
                        await delay(5000);
                    }
                    catch (error) {
                        console.log(error);
                        UIService.addToast('Ocorreu um erro ao guardar os dados. Verifique a ligação e tente novamente');
                    }
                    o.destroy();
                    if (missingParametros.length == 0 && missingEnsaios.length == 0) {
                        setEditing(!editing);
                    }
                    fetchData();
                }
            }
        }
        else {
            const updatedResultado = {
                ...data,
                resultadoId: 0
            };
            setData(updatedResultado);
            setEditing(true);
        }
    };
    const confirmNewVersion = async () => {
        const d = await UIService.showConfirm('Tem a certeza que pretende criar uma nova versão do relatório?');
        if (d) {
            // Save data
            try {
                let resposta = await ListaRelatorioService.cloneResposta(data.id);
                $state.go('app.administration.relatorios.edit', { id: resposta.id }, { notify: true, reload: true });
            }
            catch (error) {
                console.log(error);
                try {
                    await UIService.showAlert('Ocorreu um erro ao clonar resposta. Verifique a ligação e tente novamente');
                }
                finally {
                    fetchData();
                }
            }
        }
    };
    const fetchData = async () => {
        setLoading(true);
        // Should not be able to do anything
        if (!$state.params.id) {
            setLoading(false);
            UIService.showAlert('Relatório inválido.');
            return;
        }
        // Fetch lista data
        let fetchedCoreListaRelatorioResposta;
        try {
            fetchedCoreListaRelatorioResposta = await ListaRelatorioService.getCoreListaRelatorioResposta($state.params.id);
            let o = JSON.parse(fetchedCoreListaRelatorioResposta.imagens ?? '[]');
            o.forEach(r => {
                r.imagem = `/api/upload/photos/download/${r.imagem}`;
            });
            setImagens(o.map(r => r.imagem));
            setRespostas(JSON.parse(fetchedCoreListaRelatorioResposta.respostas));
            setData(fetchedCoreListaRelatorioResposta);
            const defeitos = await ListaRelatorioService.findDefeitosByTipo(fetchedCoreListaRelatorioResposta.CoreListaRelatorio.coreDepartamentoId);
            setDefects(defeitos);
            const motivosList = await ListaRelatorioService.getMotivos();
            setListaMotivos(motivosList);
            const formPagam = await ListaRelatorioService.getFormasPagamento();
            setFormasPagamento(formPagam);
            // Mapear as propriedades do `fetchedCoreListaRelatorioResposta` para `Detalhes`
            const detalhesData = {
                versao: fetchedCoreListaRelatorioResposta.versao || 1, // Supondo que a versão começa em 1 se não estiver definida
                dataSubmissao: fetchedCoreListaRelatorioResposta.dataSubmissao ? moment(fetchedCoreListaRelatorioResposta.dataSubmissao).format('YYYY-MM-DD') : 'N/D',
                tecnicoId: fetchedCoreListaRelatorioResposta.tecnicoId,
                validado: fetchedCoreListaRelatorioResposta.validado,
                realizada: fetchedCoreListaRelatorioResposta.realizada,
                motivoId: fetchedCoreListaRelatorioResposta.motivoId,
                resultadoId: fetchedCoreListaRelatorioResposta.resultadoId,
                observacoes: fetchedCoreListaRelatorioResposta.observacoes || 'N/D',
                assinatura: fetchedCoreListaRelatorioResposta.assinatura,
                pagamentoRecibo: fetchedCoreListaRelatorioResposta.pagamentoRecibo,
                pagamentoMontante: fetchedCoreListaRelatorioResposta.pagamentoMontante,
                pagamentoData: fetchedCoreListaRelatorioResposta.pagamentoData,
                pagamentoFormaId: fetchedCoreListaRelatorioResposta.pagamentoFormaId
            };
            // Atualizar o estado `detalhes` com os valores mapeados
            setDetalhes(detalhesData);
            // push parametros não preenchidos para o missingParametros - para obrigar a preencher todos
            fetchedCoreListaRelatorioResposta.CoreListaRelatorio.Parametros.map(param => {
                param.Pontos.map(ponto => {
                    const x = JSON.parse(fetchedCoreListaRelatorioResposta.respostas).parametros.find(resposta => resposta.id == ponto.id);
                    if (ponto.designacao.indexOf('[Texto]') > -1) {
                        //console.log(x);
                        if (x.pontos.length == 0) {
                            setMissingParametros(oldArray => [...oldArray, ponto]);
                        }
                        else {
                            x.pontos.map(p => {
                                if (p == '') {
                                    setMissingParametros(oldArray => [...oldArray, ponto]);
                                }
                            });
                        }
                    }
                    if (x && x.valor == '') {
                        setMissingParametros(oldArray => [...oldArray, ponto]);
                    }
                });
            });
            // push ensaios não preenchidos para o missingEnsaios - para obrigar a preencher todos
            fetchedCoreListaRelatorioResposta.CoreListaRelatorio.Ensaios.map(ensaio => {
                ensaio.Pontos.map(ponto => {
                    const x = JSON.parse(fetchedCoreListaRelatorioResposta.respostas).parametros.find(resposta => resposta.id == ponto.id);
                    if (x.valor == '') {
                        setMissingEnsaios(oldArray => [...oldArray, ponto]);
                    }
                });
            });
        }
        catch (error) {
            console.log(error);
            UIService.addToast('Erro na consulta de Relatório.');
            // Como voltar atrás em caso de erro?
        }
        setLoading(false);
    };
    useEffect(() => {
        fetchData();
    }, []);
    const onDialogDefeitosClose = (defeitos, i, pontoId, lastToggleValue) => {
        if (defeitos) {
            const newRespostas = {
                ...respostas,
                parametros: respostas.parametros.map(param => (param.id === pontoId ? { ...param, defeitos: defeitos, valor: 'NC' } : param))
            };
            // Atualizar o estado respostas
            setRespostas(newRespostas);
            // Update global data too
            setData({ ...data, respostas: JSON.stringify(newRespostas) });
        }
        else if (lastToggleValue !== undefined) {
            const restoredRespostas = {
                ...respostas,
                parametros: respostas.parametros.map((param, index) => (param.id === pontoId ? { ...param, valor: lastToggleValue } : param))
            };
            // Atualizar o estado respostas com o valor anterior
            setRespostas(restoredRespostas);
            // Atualizar os dados globais
            setData({ ...data, respostas: JSON.stringify(restoredRespostas) });
        }
    };
    const handleTabParametroChange = (event, newValue) => {
        setTabParametroIndex(newValue);
    };
    const handleTabEnsaioChange = (event, newValue) => {
        setTabEnsaioIndex(newValue);
    };
    const handleTabEquipamentoChange = (event, newValue) => {
        setTabEquipamentoIndex(newValue);
    };
    const handleParametroChange = (i, newValue, defeitosValidacao, pontoId, toggleValue) => {
        if (newValue != null) {
            // Create a copy of the respostas object
            const newRespostas = {
                ...respostas,
                parametros: respostas.parametros.map((param, index) => (index === i ? { ...param, valor: newValue } : param) // Change the index, keep the rest
                )
            };
            // Update respostas
            setRespostas(newRespostas);
            // Update global data too
            setData({ ...data, respostas: JSON.stringify(newRespostas) });
            // Open dialog if newValue is "NC"
            if (newValue === 'NC') {
                handleDefeitos(defeitosValidacao, i, pontoId, toggleValue);
            }
            else {
                //setDefectsList(l => l.filter(item => item.pontoId !== pontoId));
                const updatedRespostas = {
                    ...newRespostas,
                    parametros: newRespostas.parametros.map(param => (param.id === pontoId ? { ...param, defeitos: [] } : param))
                };
                setRespostas(updatedRespostas);
                setData({ ...data, respostas: JSON.stringify(updatedRespostas) });
            }
        }
        else {
            // Do nothing, we can't unselect...
        }
    };
    const handleImage = (file, index, pontoId) => {
        if (file == null) {
            respostas.parametros.find(x => x.id == pontoId).pontos = [];
            setSelectedFile(null);
            setNewImageUrl(null);
            return;
        }
        else if (!file.dummy) {
            respostas.parametros.find(x => x.id == pontoId).pontos[index] = file.name; /// filtar pelo id -> alterar [''] para nome da imagem
            setNewImageUrl(URL.createObjectURL(file));
            setSelectedFile(file);
        }
        const formData = new FormData();
        formData.append('file', file);
    };
    const handleDefeitos = async (validacao, i, pontoId, toggleValue) => {
        let loadDefects = [];
        respostas.parametros.map(param => {
            if (param.id == pontoId) {
                param.defeitos.map(defeito => {
                    loadDefects.push(defeito);
                });
            }
        });
        showModal(DialogDefeitos, {
            number: i,
            pontoId: pontoId,
            validation: validacao,
            title: 'Defeitos',
            defeitos: defects,
            loadDefects: loadDefects,
            lastToggleValue: toggleValue,
            type: 'Defeitos',
            onClose: (d, i) => onDialogDefeitosClose(d, i, pontoId, toggleValue)
        });
    };
    const handleEnsaioChange = (newValue, i, pontoId) => {
        if (newValue != null) {
            if (newValue) {
                setMissingEnsaios(prev => prev.filter(missing => missing.id !== pontoId));
            }
            else if (newValue == '') {
                // quando remove o valor da caixa de texto
                // push ensaios não preenchidos para o missingEnsaios - para obrigar a preencher todos
                let temp;
                let adicionaPonto;
                data.CoreListaRelatorio.Ensaios.map(ensaio => {
                    temp = ensaio.Pontos.find(ponto => ponto.id == pontoId);
                    if (temp) {
                        adicionaPonto = temp;
                    }
                });
                setMissingEnsaios(oldArray => [...oldArray, adicionaPonto]);
            }
            // Create a copy of the respostas object
            const newRespostas = {
                ...respostas,
                ensaios: respostas.ensaios.map((param, index) => (index === i ? { ...param, valor: newValue } : param) // Change the index, keep the rest
                )
            };
            // Update respostas
            setRespostas(newRespostas);
            // Update global data too
            setData({ ...data, respostas: JSON.stringify(newRespostas) });
        }
        else {
            // Do nothing, we can't unselect...
        }
    };
    const handleEquipamentoChange = (i, newValue) => {
        if (newValue != null) {
            // Create a copy of the respostas object
            const newRespostas = {
                ...respostas,
                equipamentos: respostas.equipamentos.map((param, index) => (index === i ? { ...param, valor: newValue } : param) // Change the index, keep the rest
                )
            };
            // Update respostas
            setRespostas(newRespostas);
            // Update global data too
            setData({ ...data, respostas: JSON.stringify(newRespostas) });
        }
        else {
            // Do nothing, we can't unselect...
        }
    };
    const handleObservacoes = (value, itemId) => {
        if (value === 'obs') {
            setAddObservations(prevState => ({
                ...prevState,
                [itemId]: !prevState[itemId]
            }));
        }
        else {
            setShowObservations(prevState => ({
                ...prevState,
                [itemId]: !prevState[itemId]
            }));
        }
    };
    const addObservacao = pontoId => {
        const newObservation = observations.find(o => o.pontoId === pontoId);
        // Create a copy of the respostas object
        const newRespostas = {
            ...respostas,
            parametros: respostas.parametros.map(param => (param.id === pontoId ? { ...param, observacoes: newObservation ? newObservation.obs : param.observacoes } : param))
        };
        // Update respostas
        setRespostas(newRespostas);
        // Update global data too
        setData({ ...data, respostas: JSON.stringify(newRespostas) });
    };
    const handlePontos = (event, pontoId, pontosIndex) => {
        //pontosIndex é para quando há mais do que uma textfield nos parametros
        const newRespostas = {
            ...respostas,
            parametros: respostas.parametros.map(param => {
                if (param.id === pontoId) {
                    // Se o array de pontos estiver vazio, adicionar o novo valor
                    if (param.pontos.length === 0) {
                        return {
                            ...param,
                            pontos: [event.target.value]
                        };
                    }
                    // Atualiza o ponto no índice correto se o array não estiver vazio
                    return {
                        ...param,
                        pontos: param.pontos.map((ponto, index) => (index === pontosIndex ? event.target.value : ponto))
                    };
                }
                return param;
            })
        };
        let ponto, res;
        if (event.target.value === '') {
            data.CoreListaRelatorio.Parametros.map(param => {
                const temp = param.Pontos.find(p => p.id == pontoId);
                if (temp) {
                    ponto = temp;
                }
            });
            res = newRespostas.parametros.find(resposta => resposta.id == pontoId);
            if (ponto.designacao.indexOf('[Texto]') > -1) {
                if (res.pontos.length == 0) {
                    setMissingParametros(oldArray => [...oldArray, ponto]);
                }
                else {
                    res.pontos.map(p => {
                        if (p == '') {
                            console.log(p);
                            setMissingParametros(oldArray => [...oldArray, ponto]);
                        }
                    });
                }
            }
            if (res.valor == '') {
                setMissingParametros(oldArray => [...oldArray, ponto]);
            }
        }
        else {
            setMissingParametros(oldArray => oldArray.filter(p => p.id !== pontoId));
        }
        // Atualizar respostas
        setRespostas(newRespostas);
        // Atualizar dados globais também
        setData({ ...data, respostas: JSON.stringify(newRespostas) });
    };
    const handleDetalhesChange = (key, value) => {
        const updatedDetalhes = {
            ...data,
            [key]: value
        };
        setData(updatedDetalhes);
    };
    const handleRealizadaChange = (event) => {
        const isChecked = event.target.checked;
        handleDetalhesChange('realizada', isChecked ? 1 : 0);
        setShowMotivos(!isChecked);
    };
    const onDialogValidacaoClose = async (res) => {
        if (res) {
            const wait = showModal(WaitDialog, { title: 'Por favor aguarde...' });
            try {
                await ListaRelatorioService.validateResposta(data.id);
                // console.log(r);
            }
            catch (error) {
                UIService.addToast('Ocorreu um erro ao guardar os dados. Verifique a ligação e tente novamente');
            }
            wait.destroy();
            fetchData();
        }
    };
    return (<Box>
      <Box sx={{ mt: 2, mb: 2 }}>
        <Typography variant='h5'>{loading ? 'A carregar...' : data?.CoreListaRelatorio.titulo}</Typography>
        <Breadcrumbs aria-label='breadcrumb'>
          <Link underline='none' color='inherit'>
            Relatórios
          </Link>
          <Link underline='none' color='inherit'>
            {loading ? <CircularProgress size={16}/> : 'Editar Relatório'}
          </Link>
        </Breadcrumbs>
      </Box>
      <Box>
        {!loading && data && data.dataSubmissao && data.processado == 0 ? (<Alert sx={{ mb: 1, mt: 1 }} severity='info'>
            A processar relatório, por favor aguarde...
          </Alert>) : undefined}
        {!loading && data && data.dataSubmissao && data.validado == 0 && data.processado == 1 ? (<Alert sx={{ mb: 1, mt: 1 }} severity='success'>
            Este relatório encontra-se submetido.
            <br />
            Utilize o botão <MdiIcon sx={{ display: 'inline' }} path={mdiCheckBold} size={0.5}/> para validar.
            <br />
            Caso pretenda fazer alterações, clique no botão "Clonar" para criar uma nova versão em rascunho.
          </Alert>) : undefined}
        {!loading && data && data.dataSubmissao && data.validado == 1 ? (<Alert sx={{ mb: 1, mt: 1 }} severity='success'>
            Este relatório encontra-se validado. Caso pretenda fazer alterações, clique no botão "Clonar" para criar uma nova versão em rascunho.
          </Alert>) : undefined}
      </Box>
      {loading || !data ? (<Box sx={{ display: 'flex', justifyContent: 'center', height: '2vh' }}>
          <CircularProgress size={60} color='primary'/>
        </Box>) : (<Box>
          {data && (<Grid container spacing={1}>
              <Grid md={6} xs={12}>
                <DynamicCard sx={{ mb: 1 }} title='Informação geral' loading={loading} content={[
                    {
                        label: 'Versão',
                        value: data?.versao
                    },
                    {
                        label: 'Data de Submissão',
                        value: data && data.dataSubmissao ? moment(data.dataSubmissao).format('DD-MM-YYYY') : 'N/D'
                    },
                    {
                        label: 'Submetido por',
                        value: data?.Tecnico.name || 'N/D'
                    },
                    {
                        label: 'Validado',
                        value: data?.validado ? 'Sim' : 'Não'
                    },
                    ...(data?.validado
                        ? [
                            {
                                label: 'Validado por',
                                value: data?.ValidadoPor?.name || 'N/D'
                            }
                        ]
                        : []),
                    ...(data?.validado
                        ? [
                            {
                                label: 'Data de Validação',
                                value: data && data.dataValidacao ? moment(data.dataValidacao).format('DD-MM-YYYY') : 'N/D'
                            }
                        ]
                        : []),
                    {
                        label: 'Resultado',
                        value: (<Stack direction='row' spacing={2} justifyContent='space-between' alignItems='center'>
                          <Typography>{data && data.dataSubmissao ? data?.CoreListaRelatorioResultado?.designacao : 'A aguardar submissão'}</Typography>{' '}
                          {data?.CoreListaRelatorioResultado?.valor === 0 || data?.CoreListaRelatorioResultado?.valor === 2 ? (<IconButton onClick={() => {
                                    const resultado = JSON.parse(data.avaliacao);
                                    const erros = { parametros: [], ensaios: [] };
                                    resultado.parametros.map(parametros => {
                                        if (parametros.resultado) {
                                            parametros.pontos.map(ponto => {
                                                data.CoreListaRelatorio.Parametros.map(params => {
                                                    let erro = params.Pontos.find(p => p.id == ponto.idPonto);
                                                    if (erro)
                                                        erros.parametros.push({ codigo: erro.codigo, designacao: erro.designacao });
                                                });
                                            });
                                        }
                                    });
                                    resultado.ensaios.map(ensaio => {
                                        if (ensaio.resultado) {
                                            erros.ensaios.push({ codigo: ensaio.observacoes, designacao: ensaio.aValidar });
                                        }
                                    });
                                    showModal(DialogResultado, {
                                        motivos: resultado,
                                        erros: erros
                                    });
                                }}>
                              <MdiIcon path={mdiMagnify}/>
                            </IconButton>) : (<Box></Box>)}
                        </Stack>)
                    }
                ]}/>
              </Grid>
              <Grid md={6} xs={12}>
                <DynamicCard sx={{ mb: 1 }} loading={loading} variant='gallery' content={imagens} title={'Fotografias'}/>
                <DynamicCard sx={{ mb: 1 }} title='Ficheiros gerados' variant='list' loading={loading} content={data.Ficheiros.filter(r => {
                    // Se não está validado, só mostra os ficheiros que ficam concluídos na validação
                    if (data.validado == 1) {
                        return true;
                    }
                    else {
                        return r.RelatorioFicheiro?.validado == 0;
                    }
                }).map(r => {
                    return {
                        avatar: (<Avatar>
                          <MdiIcon path={mdiFileDocument}/>
                        </Avatar>),
                        label: r.RelatorioFicheiro.designacao,
                        actions: [
                            <Box key={r.ficheiro}>
                          {!loading && (<Tooltip title='Visualizar ficheiro'>
                              <IconButton onClick={() => {
                                        window.open(`/api/Upload/output/download/${r.ficheiro}`, '_blank');
                                    }}>
                                <MdiIcon path={mdiMagnify}/>
                              </IconButton>
                            </Tooltip>)}
                        </Box>
                        ]
                    };
                })}/>
              </Grid>
            </Grid>)}
          <Grid container spacing={1}>
            <Grid md={12} xs={12}>
              {/* <DynamicCard
              sx={{ mb: 1 }}
              title='Fotografias'
              variant='gallery'
              loading={loading}
              content={
                JSON.parse(data.imagens) == null ? (
                  <Box></Box>
                ) : (
                  JSON.parse(data.imagens).map(img => {
                    <Box
                      component='img'
                      src={`/common/uploads/photos/${img.image}`}
                      alt='Uploaded'
                      //style={{ maxWidth: "50%", marginTop: "10px" }}
                      sx={{
                        maxWidth: '500px',
                        maxHeight: '500px',
                        width: 'auto',
                        height: 'auto'
                      }}></Box>;
                  })
                )
              }
            /> */}
            </Grid>
            <Grid md={data.CoreListaRelatorio && data.CoreListaRelatorio.pagamento ? 6 : 12} xs={12}>
              <Card sx={{ mb: 1 }}>
                <CardHeader title='Detalhes'/>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid lg={data.CoreListaRelatorio && data.CoreListaRelatorio.pagamento ? 12 : 3} md={data.CoreListaRelatorio && data.CoreListaRelatorio.pagamento ? 12 : 4} xs={data.CoreListaRelatorio && data.CoreListaRelatorio.pagamento ? 12 : 4}>
                      <TextField defaultValue={data.realizada} disabled={!editing} label='Realizada?' fullWidth onChange={e => handleDetalhesChange('realizada', e.target.value)} select>
                        {[
                { id: 0, designacao: 'Não' },
                { id: 1, designacao: 'Sim' }
            ]?.map(item => (<MenuItem key={item.id} value={item.id}>
                            {item.designacao}
                          </MenuItem>))}
                      </TextField>
                    </Grid>
                    <Grid lg={data.CoreListaRelatorio && data.CoreListaRelatorio.pagamento ? 12 : 9} md={data.CoreListaRelatorio && data.CoreListaRelatorio.pagamento ? 12 : 8} xs={data.CoreListaRelatorio && data.CoreListaRelatorio.pagamento ? 12 : 8}>
                      <TextField defaultValue={data.Motivo?.designacao} disabled={!editing || data?.realizada == 1} label='Se não realizada, indique o motivo' fullWidth onChange={e => handleDetalhesChange('motivoId', e.target.value)} select>
                        <MenuItem value={undefined} disabled></MenuItem>
                        {listaMotivos.map(item => (<MenuItem key={item.id} value={item.id}>
                            {item.designacao}
                          </MenuItem>))}
                      </TextField>
                    </Grid>
                    <Grid lg={12} md={12} xs={12}>
                      <TextField disabled={!editing} label='Observações' defaultValue={data.observacoes} onChange={e => handleDetalhesChange('observacoes', e.target.value)} fullWidth/>
                    </Grid>
                    <Grid lg={12} md={12} xs={12}>
                      <TextField disabled={!editing} label='Notas internas' defaultValue={data.notas} onChange={e => handleDetalhesChange('notas', e.target.value)} fullWidth/>
                    </Grid>
                    {data.CoreListaRelatorio && data.CoreListaRelatorio.assinatura && (<Grid lg={12} md={12} xs={12}>
                        <Box>
                          <Button disabled={!editing} size='large' variant='outlined' sx={{
                    minHeight: '1.4375em',
                    height: 'auto',
                    padding: '14px 14px'
                }} onClick={() => {
                    showModal(DialogAssinatura, {
                        ListaRelatorioService: ListaRelatorioService,
                        initial: detalhes.assinatura,
                        title: 'Assinatura do cliente',
                        onClose: (assinatura) => {
                            if (assinatura) {
                                handleDetalhesChange('assinatura', assinatura);
                            }
                        }
                    });
                }}>
                            Assinatura do cliente
                          </Button>
                          <Button size='large' disabled={!detalhes || !detalhes.assinatura} sx={{
                    minHeight: '1.4375em',
                    height: 'auto',
                    padding: '14px 14px',
                    ml: 2
                }} onClick={() => {
                    window.open(`/api/upload/photos/download/${detalhes.assinatura}`, '_blank');
                }}>
                            Visualizar
                          </Button>
                        </Box>
                      </Grid>)}
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            {data.CoreListaRelatorio && data.CoreListaRelatorio.pagamento && (<Grid md={data.CoreListaRelatorio && data.CoreListaRelatorio.pagamento ? 6 : 12} xs={12}>
                <Card sx={{ mb: 1 }}>
                  <CardHeader title='Pagamento' subheader=''/>
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid lg={12} md={12} xs={12}>
                        <TextField disabled={!editing} label='Nº recibo' defaultValue={data.pagamentoRecibo} onChange={e => handleDetalhesChange('pagamentoRecibo', e.target.value)} fullWidth/>
                      </Grid>
                      <Grid lg={12} md={12} xs={12}>
                        <TextField disabled={!editing} label='Montante' defaultValue={data.pagamentoMontante} onChange={e => handleDetalhesChange('pagamentoMontante', e.target.value)} fullWidth type='number' InputProps={{
                    endAdornment: <InputAdornment position='end'>€</InputAdornment>
                }}/>
                      </Grid>
                      <Grid lg={12} md={12} xs={12}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <DateTimePicker label='Data/Hora' disabled={!editing} format='DD/MM/YYYY HH:mm' defaultValue={data.pagamentoData ? moment(data.pagamentoData) : undefined} onChange={value => handleDetalhesChange('pagamentoData', value)} slotProps={{
                    textField: {
                        disabled: !editing,
                        variant: 'outlined',
                        id: 'dataAgendamento',
                        name: 'dataAgendamento',
                        fullWidth: true
                    }
                }}/>
                        </LocalizationProvider>
                      </Grid>
                      <Grid lg={12} md={12} xs={12}>
                        <TextField disabled={!editing} label='Forma de Pagamento' defaultValue={data.pagamentoFormaId} onChange={e => handleDetalhesChange('pagamentoFormaId', e.target.value)} fullWidth select>
                          <MenuItem value={undefined} disabled></MenuItem>
                          {formasPagamento.map(item => (<MenuItem key={item.id} value={item.id}>
                              {item.designacao}
                            </MenuItem>))}
                        </TextField>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>)}
          </Grid>

          {data?.CoreListaRelatorio.Parametros.length > 0 && (<Grid container spacing={1}>
              <Grid md={12} xs={12}>
                <Card sx={{ mb: 1 }}>
                  <CardHeader title='Parâmetros' subheader=''/>
                  <Box>
                    <Tabs scrollButtons={true} allowScrollButtonsMobile={true} variant='scrollable' value={tabParametroIndex} onChange={handleTabParametroChange} aria-label='Tab Relatório'>
                      {data?.CoreListaRelatorio.Parametros.map(parametro => {
                    return <Tab key={parametro.id} label={`${parametro.codigo} - ${parametro.designacao}`}/>;
                })}
                    </Tabs>
                    <List>
                      {data?.CoreListaRelatorio.Parametros[tabParametroIndex]?.Pontos.map(ponto => {
                    let i = respostas.parametros.findIndex(x => x.id === ponto.id);
                    const pontoRespostas = respostas.parametros[i]?.pontos;
                    let pontosIndex = -1;
                    return (<List key={ponto.id}>
                            <ListItem key={ponto.id} style={{ display: 'flex', flexWrap: 'wrap' }}>
                              {ponto.codigo}&nbsp;-&nbsp;
                              {ponto.designacao.split(/\s+/).map((r, index) => {
                            /// REGEX -> verificar de r tem [Texto]
                            if (/\[Texto\]/.test(r)) {
                                pontosIndex++;
                                const currentIndex = pontosIndex;
                                return (<React.Fragment key={index}>
                                      &nbsp;
                                      <TextField size='small' required variant='outlined' onChange={event => handlePontos(event, ponto.id, currentIndex)} defaultValue={pontoRespostas && pontoRespostas[currentIndex] ? pontoRespostas[currentIndex] : ''} disabled={!editing}/>
                                      &nbsp;&nbsp;
                                    </React.Fragment>);
                            }
                            /// REGEX -> verificar de r tem [Numero]
                            if (/\[Numero\]/.test(r)) {
                                pontosIndex++;
                                return (<React.Fragment key={index}>
                                      &nbsp;
                                      <TextField size='small' required variant='outlined' defaultValue={pontoRespostas && pontoRespostas[pontosIndex] ? pontoRespostas[pontosIndex] : ''} inputProps={{ type: 'number' }} disabled={!editing}/>
                                      &nbsp;&nbsp;
                                    </React.Fragment>);
                            }
                            /// REGEX -> verificar de r tem [Data/Hora]
                            if (/\[Data\/Hora\]/.test(r)) {
                                pontosIndex++;
                                return (<React.Fragment key={index}>
                                      &nbsp;
                                      <TextField size='small' required variant='outlined' defaultValue={pontoRespostas[pontosIndex]} 
                                //inputProps={{ type: 'number' }}
                                disabled={!editing}/>
                                      &nbsp;&nbsp;
                                    </React.Fragment>);
                            }
                            /// REGEX -> verificar de r tem [Imagem]
                            if (/\[Imagem\]/.test(r)) {
                                pontosIndex++;
                                return (<React.Fragment key={index}>
                                      &nbsp;
                                      <Tooltip title={pontoRespostas.length == 0 ? 'Adicionar imagem' : 'Alterar imagem'}>
                                        <Button variant='outlined' size='small' disabled={!editing} onClick={() => {
                                        showModal(DialogImage, {
                                            image: pontoRespostas[pontosIndex],
                                            index: pontosIndex,
                                            onClose: (file, index) => handleImage(file, index, ponto.id)
                                        });
                                    }}>
                                          <MdiIcon path={mdiImagePlus}/>
                                        </Button>
                                      </Tooltip>
                                      &nbsp;&nbsp;
                                    </React.Fragment>);
                            }
                            return (<Typography key={index} style={{
                                    overflowWrap: 'break-word',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word'
                                    //marginBottom: '8px'
                                }}>
                                    {r}&nbsp;
                                  </Typography>);
                        })}
                            </ListItem>
                            <ListItem>
                              <Stack direction={'column'} justifyContent='space-between' sx={{ width: '100%' }} spacing={2}>
                                <Stack direction='row' justifyContent='space-between' sx={{ width: '100%' }}>
                                  <ToggleButtonGroup size='small' exclusive onChange={(event, newValue) => handleObservacoes(newValue, ponto.id)}>
                                    <ToggleButton sx={{ width: 50 }} value='showObs'>
                                      {showObservations[ponto.id] ? <Icon path={mdiMinusCircleOutline} size={1}/> : <Icon path={mdiPlusCircleOutline} size={1}/>}
                                    </ToggleButton>
                                    <ToggleButton sx={{ width: 50 }} value='obs' disabled={!editing}>
                                      Obs
                                    </ToggleButton>
                                  </ToggleButtonGroup>

                                  <ToggleButtonGroup size='small' value={i < 0 ? undefined : respostas?.parametros[i]?.valor} // If we can't find the index (should not happen)
                     disabled={!editing} exclusive onChange={(event, newValue) => {
                            handleParametroChange(i, newValue, ponto.defeitos, ponto.id, respostas?.parametros[i]?.valor);
                            if (respostas?.parametros[i]?.valor === 'NC' && newValue === null) {
                                handleDefeitos(ponto.defeitos, i, ponto.id, respostas?.parametros[i]?.valor);
                            }
                            if (newValue) {
                                setMissingParametros(prev => prev.filter(missing => missing.id !== ponto.id));
                            }
                        }}>
                                    <ToggleButton sx={{ width: 50 }} value='C' color='success'>
                                      C
                                    </ToggleButton>
                                    <ToggleButton sx={{ width: 50 }} value='NC' color='error'>
                                      NC
                                    </ToggleButton>
                                    <ToggleButton sx={{ width: 50 }} value='NA' color='info'>
                                      NA
                                    </ToggleButton>
                                  </ToggleButtonGroup>
                                </Stack>
                                {addObservations[ponto.id] ? (<Box>
                                    <Stack direction={'row'} spacing={2}>
                                      <TextField id='standard-multiline-static' label='Observações Internas' defaultValue={i >= 0 ? respostas.parametros[i].observacoes : ''} multiline rows={4} variant='standard' fullWidth onChange={event => {
                                const newObservacoes = event.target.value;
                                setObservations(prevState => {
                                    const newState = [...prevState];
                                    const obsIndex = newState.findIndex(obs => obs.pontoId === ponto.id);
                                    if (obsIndex > -1) {
                                        newState[obsIndex] = { pontoId: ponto.id, obs: newObservacoes };
                                    }
                                    else {
                                        newState.push({ pontoId: ponto.id, obs: newObservacoes });
                                    }
                                    return newState;
                                });
                            }}/>
                                      <Button onClick={() => addObservacao(i + 1)}>Guardar</Button>
                                    </Stack>
                                  </Box>) : (<Box></Box>)}
                                {showObservations[ponto.id] ? (<List sx={{ width: '100%', bgcolor: '#e5e5e5' }} dense>
                                    {respostas.parametros[i].pontos.map((p, idx) => {
                                /// REGEX -> se p for string com .png / jpeg ... mostra o botão
                                if (/([a-zA-Z0-9-_]+\.(jpeg|jpg|png|bmp))/.test(p)) {
                                    return (<ListItem key={p || idx} sx={{
                                            position: 'absolute',
                                            flexDirection: 'row-reverse'
                                        }}>
                                            <ListItemAvatar>
                                              <Avatar variant='square' sx={{ width: 120, height: 120, zIndex: 1000 }} src={`/api/upload/photos/download/${pontoRespostas[pontosIndex]}`} onClick={() => {
                                            newImageUrl == null ? window.open(`/api/upload/photos/download/${pontoRespostas[pontosIndex]}`, '_blank') : window.open(newImageUrl, '_blank');
                                        }}/>
                                            </ListItemAvatar>
                                          </ListItem>);
                                }
                                else {
                                    return <Box></Box>;
                                }
                            })}
                                    {defects.map((d, index) => {
                                const param = respostas.parametros.find(param => param.id === ponto.id);
                                if (param) {
                                    if (param.defeitos.length === 0) {
                                        return (<ListItem key={index}>
                                              <ListItemText primary={<Box sx={{ fontWeight: 'bold' }}>{d.designacao}</Box>} secondary='Sem Defeitos'/>
                                            </ListItem>);
                                    }
                                    else {
                                        const defectItems = d.Defeitos.filter(def => param.defeitos.some(dl => dl.id === def.id)).map((def, defIndex) => {
                                            const defectData = param.defeitos.find(dl => dl.id === def.id);
                                            return (<ListItem key={def.id}>
                                                <ListItemText primary={`${def.titulo} - ${def.subtitulo}`} secondary={defectData ? defectData.nota : ''}/>
                                              </ListItem>);
                                        });
                                        if (defectItems.length === 0) {
                                            return (<ListItem key={index}>
                                                <ListItemText primary={<Box sx={{ fontWeight: 'bold' }}>{d.designacao}</Box>} secondary='Sem Defeitos'/>
                                              </ListItem>);
                                        }
                                        return (<React.Fragment key={index}>
                                              <ListItem>
                                                <ListItemText primary={<Box sx={{ fontWeight: 'bold' }}>{d.designacao}</Box>}/>
                                              </ListItem>
                                              {defectItems}
                                            </React.Fragment>);
                                    }
                                }
                                return null;
                            })}
                                    <ListItem>
                                      <ListItemText primary={<Box sx={{ fontWeight: 'bold' }}>Observações</Box>} secondary={respostas.parametros.find(x => x.id === ponto.id).observacoes === '' ? 'Sem observações' : respostas.parametros.find(x => x.id === ponto.id).observacoes}/>
                                    </ListItem>
                                  </List>) : (<Box></Box>)}
                              </Stack>
                            </ListItem>
                          </List>);
                })}
                    </List>
                  </Box>
                </Card>
              </Grid>
            </Grid>)}
          {data?.CoreListaRelatorio.Ensaios.length > 0 && (<Grid container spacing={1}>
              <Grid md={12} xs={12}>
                <Card sx={{ mb: 1 }}>
                  <CardHeader title='Ensaios' subheader=''/>
                  <Box>
                    <Tabs scrollButtons={true} allowScrollButtonsMobile={true} variant='scrollable' value={tabEnsaioIndex} onChange={handleTabEnsaioChange} aria-label='Tab Relatório'>
                      {data?.CoreListaRelatorio.Ensaios.map(ensaio => {
                    return <Tab key={ensaio.id} label={`${ensaio.codigo} - ${ensaio.designacao}`}/>;
                })}
                    </Tabs>
                    <List>
                      {data?.CoreListaRelatorio.Ensaios[tabEnsaioIndex]?.Pontos.map(ponto => {
                    let i = respostas.ensaios.findIndex(x => x.id === ponto.id);
                    return (<ListItem key={ponto.id}>
                            <ListItemText onClick={() => { }} primary={`${ponto.codigo} - ${ponto.designacao}`}/>
                            <InputComponent tipo={ponto.tipo} formato={ponto.formato} inputChange={newValue => handleEnsaioChange(newValue, i, ponto.id)} value={respostas.ensaios[i] == undefined || respostas.ensaios[i].valor == undefined ? '' : respostas.ensaios[i].valor} index={i} sx={{ width: 250 }} inputProps={{
                            disable: !editing
                        }}/>
                          </ListItem>);
                })}
                    </List>
                  </Box>
                </Card>
              </Grid>
            </Grid>)}
          {data?.CoreListaRelatorio.Equipamentos.length > 0 && (<Grid container spacing={1}>
              <Grid md={12} xs={12}>
                <Card sx={{ mb: 1 }}>
                  <CardHeader title='Equipamentos' subheader=''/>
                  <Box>
                    <Tabs scrollButtons={true} allowScrollButtonsMobile={true} variant='scrollable' value={tabEquipamentoIndex} onChange={handleTabEquipamentoChange} aria-label='Tab Relatório'>
                      {data?.CoreListaRelatorio.Equipamentos.map(equipamento => {
                    return <Tab key={equipamento.id} label={`${equipamento.designacao}`}/>;
                })}
                    </Tabs>
                    <List>
                      {data?.CoreListaRelatorio.Equipamentos[tabEquipamentoIndex]?.Pontos.map(ponto => {
                    let i = respostas.equipamentos.findIndex(x => x.id === ponto.id);
                    return (<ListItem key={ponto.id}>
                            <ListItemText onClick={() => { }} primary={`${ponto.codigo} - ${ponto.designacao}`}/>
                            {/*TODO - Fix to proper TextField*/}
                            <TextField disabled={!editing} sx={{ width: 200 }} value={respostas.equipamentos[i]?.valor} onChange={event => {
                            handleEquipamentoChange(i, event.target.value);
                        }}/>
                          </ListItem>);
                })}
                    </List>
                  </Box>
                </Card>
              </Grid>
            </Grid>)}
        </Box>)}
      {!loading && (<Box sx={{
                position: 'fixed',
                margin: 2,
                bottom: 0,
                right: 0,
                display: 'flex',
                gap: 1
            }}>
          {!data?.validado && !data.dataSubmissao && (<Tooltip title={editing ? 'Guardar alterações' : 'Editar'}>
              <Fab color={editing ? 'error' : 'primary'} onClick={() => isEditing()}>
                <MdiIcon path={editing ? mdiContentSave : mdiPencil}/>
              </Fab>
            </Tooltip>)}
          {data &&
                userId === data.CoreListaRelatorio.Departamento.Responsavel.funcionarioId && // Only validador can see
                !data?.validado &&
                !editing &&
                data.realizada &&
                data.dataSubmissao && ( /// && permissões para validar
            <Tooltip title={'Validar relatório'} onClick={() => showModal(DialogValidacao, {
                    title: 'Validar relatório do relatório',
                    onClose: onDialogValidacaoClose
                })}>
                <Fab color={'success'}>
                  <MdiIcon path={mdiCheckBold}/>
                </Fab>
              </Tooltip>)}
          {data?.dataSubmissao ? (<Tooltip title='Nova versão'>
              <Fab variant='extended' onClick={() => confirmNewVersion()}>
                <MdiIcon path={mdiWindowRestore} sx={{ mr: 1 }}/>
                Clonar
              </Fab>
            </Tooltip>) : undefined}
        </Box>)}
    </Box>);
};
export default EditRelatorios;
